(() => {
    for (const root of document.querySelectorAll('[data-sg-product]')) {
    if (root.dataset.ready) continue;
    root.dataset.ready = 'true';
    const variantsNode = root.querySelector('[data-sg-variants]');
    const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
    const byId = new Map(variants.map(v => [String(v.id), v]));
    const currency = root.dataset.currency || 'USD';
    const format = n => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency}).format(n / 100);
    const form = root.querySelector('[data-bundle-form]');
    const button = form.querySelector('[type=submit]');
    const error = form.querySelector('[data-cart-error]');
    const selected = n => [...form.querySelectorAll(`[data-pack-sizes="${n}"] select`)].map(s => byId.get(s.value));
    const quantity = () => Number(form.querySelector('[name=quantity]:checked').value);
    function refresh(updateURL = false) {
    const n = quantity();
    for (const group of form.querySelectorAll('[data-pack-sizes]')) {
    group.hidden = Number(group.dataset.packSizes) !== n;
    for (const select of group.querySelectorAll('select')) select.disabled = group.hidden;
    }
    for (let pack = 1; pack <= 3; pack++) {
    const choices = selected(pack);
    const prices = choices.length === pack && choices.every(Boolean) ? choices.map(v => v.price) : Array(pack).fill(Number(root.dataset.price));
    const full = prices.reduce((a,b) => a+b,0);
    const total = pack === 1 ? full : pack === 2 ? full-Math.floor(Math.min(...prices)*.5) : full-Math.min(...prices);
    root.querySelector(`[data-total="${pack}"]`).textContent = format(total);
    root.querySelector(`[data-original="${pack}"]`).textContent = format(choices.length === pack && choices.every(Boolean) ? choices.reduce((a,v) => a+(v.compare_at_price || v.price),0) : Number(root.dataset.compare)*pack);
    }
    const choices = selected(n);
    const unavailable = choices.length !== n || choices.some(v => !v || !v.available);
    button.disabled = unavailable;
    button.textContent = unavailable ? 'CURRENTLY UNAVAILABLE' : 'ADD TO CART';
    if (updateURL && choices[0] && location.pathname.includes('/products/')) {
    const url = new URL(location.href); url.searchParams.set('variant', choices[0].id); history.replaceState({},'',url);
    }
    }
    if (variantsNode) {
    for (const radio of form.querySelectorAll('[name=quantity]')) radio.addEventListener('change',() => refresh());
    for (const select of form.querySelectorAll('[data-size-select]')) select.addEventListener('change',() => refresh(true));
    refresh();
    } else {
    const price = Number(root.dataset.price), compare = Number(root.dataset.compare);
    for(let n=1;n<=3;n++){root.querySelector(`[data-total="${n}"]`).textContent=format(n===1?price:n===2?price+Math.round(price*.5):price*2);root.querySelector(`[data-original="${n}"]`).textContent=format(compare*n);}
    }
    for (const photo of root.querySelectorAll('[data-photo]')) photo.addEventListener('click',() => {
    root.querySelector('[data-main-image]').src=photo.dataset.photo;
    for (const x of root.querySelectorAll('[data-photo]')) x.setAttribute('aria-pressed',String(x===photo));
    });
    form.addEventListener('submit',async event => {
    event.preventDefault();button.disabled=true;button.textContent='ADDING…';error.textContent='';
    try {
    const n=quantity();if(![1,2,3].includes(n))throw Error('Please choose a bundle.');
    const items=new Map();
    if(variantsNode){const choices=selected(n);if(choices.length!==n||choices.some(v=>!v||!v.available))throw Error('Please select an available size for every pair.');for(const v of choices)items.set(v.id,(items.get(v.id)||0)+1);}
    else {if(!root.dataset.variant)throw Error('Please choose an available product.');items.set(Number(root.dataset.variant),n);}
    const res=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[...items].map(([id,quantity])=>({id,quantity}))})});
    const data=await res.json();if(!res.ok)throw Error(data.description||'Unable to add this bundle. Please try again.');location.href=(window.Shopify?.routes?.root||'/')+'cart';
    }catch(e){error.textContent=e.message;if(variantsNode)refresh();else{button.disabled=false;button.textContent='ADD TO CART';}}
    });
    const sticky=document.querySelector('[data-sticky]');if(sticky)new IntersectionObserver(entries=>sticky.classList.toggle('visible',!entries[0].isIntersecting),{threshold:0}).observe(form);
    }
    })();

